import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, CheckCircle2, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { certError } from "@/lib/certs";

const fmtTime = (v) => (v ? new Date(v).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "");

// Direct PDF send through WhatsApp Business (Meta Cloud API), only inside the 24-hour window.
export const WhatsAppDirectSend = ({ cert }) => {
  const [w, setW] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/certificates/${cert.id}/whatsapp-window`).then(({ data }) => setW(data)).catch(() => setW(null));
  useEffect(() => { load(); }, [cert.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!w) return null;
  if (!w.enabled) return <p className="text-xs text-muted-foreground" data-testid="wa-direct-disabled">Direct PDF sending isn't set up yet: WhatsApp Business is not connected.</p>;
  const send = async () => {
    setBusy(true);
    try { await api.post(`/certificates/${cert.id}/whatsapp-send`); toast.success("Certificate PDF sent on WhatsApp"); load(); }
    catch (e) { toast.error(await certError(e)); load(); }
    setBusy(false);
  };
  return (
    <div className="space-y-2 rounded-lg border border-emerald-500/30 bg-emerald-500/5 p-3" data-testid="wa-direct-send">
      <p className="text-xs font-semibold">Send the PDF directly (WhatsApp Business)</p>
      {!w.has_phone ? <p className="text-xs text-muted-foreground">No mobile number on file for this partner.</p>
        : w.window_open ? <p className="flex items-center gap-1.5 text-xs text-emerald-500" data-testid="wa-window-open"><CheckCircle2 className="h-3.5 w-3.5" />Partner messaged at {fmtTime(w.last_inbound_at)}. You can send until {fmtTime(w.window_closes_at)}.</p>
          : <p className="flex items-start gap-1.5 text-xs text-amber-500" data-testid="wa-window-closed"><Clock className="mt-0.5 h-3.5 w-3.5 shrink-0" />WhatsApp only allows sending files within 24 hours of the partner's last message. Ask them to send any message (e.g. "Hi") to your WhatsApp Business number, then send.{w.last_inbound_at ? ` Last message: ${fmtDate(w.last_inbound_at)}.` : ""}</p>}
      {w.last_sent && <p className="text-[11px] text-muted-foreground" data-testid="wa-last-sent">Last sent {fmtTime(w.last_sent.sent_at)} by {w.last_sent.sent_by} · {w.last_sent.status}{w.last_sent.error ? ` (${w.last_sent.error})` : ""}</p>}
      <Button size="sm" onClick={send} disabled={busy || !w.window_open} className="bg-emerald-600 hover:bg-emerald-700" data-testid="wa-direct-send-btn">
        <Send className="mr-1.5 h-3.5 w-3.5" />{busy ? "Sending…" : "Send PDF on WhatsApp"}
      </Button>
    </div>
  );
};
